import React from 'react';
import Navbar from '../pages/Navbar';
import JourneySection from '../pages/JourneySection';
import Footer from '../pages/Footer';
import SEO from '../components/SEO';

function JourneyPage() {
  return (
    <>
      <SEO
        title="Pooja's Journey — LLM, Contract Law & Professional Growth"
        description="Follow Pooja Biswal's journey — from LLM (Distinction) at Queen Mary University of London to contract specialist helping freelancers and businesses across the UK."
        keywords="Pooja Biswal journey, LLM Queen Mary London, contract law career, legal career path UK, contract specialist story"
        canonical="/journey"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Journey", path: "/journey" }]}
      />
      <Navbar />
      <JourneySection />
      <Footer />
    </>
  );
}

export default JourneyPage;
